export default __webpack_public_path__ + "static/media/img_websphere_mq-colorBkg.50f25cc2.png";